import { useEffect } from "react";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

export default function TestPage() {
  const axiosPriv = useAxiosPrivate();

  useEffect(() => {
    let mounted = true;
    const test = async () => {
      try {
        // pegá a un endpoint privado real que tengas
        const { data } = await axiosPriv.get("users");
        if (mounted) console.log("✅ OK users:", data);
      } catch (e) {
        console.error("❌ Error users:", e?.response?.status, e?.message);
      }
    };
    test();
    return () => {
      mounted = false;
    };
  }, [axiosPriv]);

  return <div>TestPage: mirá la consola y el Network tab 🚀</div>;
}
